import React from 'react';
import { css } from '@emotion/css';

import { StyleLibrary } from '@vm/omega-shared-component-webapp';
const { mqBreakpoints, pxToRem } = StyleLibrary;

import ImageSection from '../shared/ImageSection';

const imgStyle = css({
  height: pxToRem(336),

  [mqBreakpoints.tablet]: {
    height: pxToRem(432),
  },
  [mqBreakpoints.desktop]: {
    height: 'initial',
  },

  img: {
    [mqBreakpoints.tablet]: {
      objectPosition: 'top',
    },

    [mqBreakpoints.desktop]: {
      objectPosition: 'left center',
    },
  },
});

type Props = {
  image: string;
};

export const HeaderImage: React.FC<Props> = ({ image }) => {
  return <ImageSection className={imgStyle} image={image} data-testid='mp-product-header-image' />;
};
